import React, { useEffect } from 'react'

const Rain = () => {
  useEffect(() => {
    const rainContainer = document.getElementById('rain-container')
    const logoSrc = '/images/logo.png' // Path to your logo image
    const numberOfLogos = 4 // Adjust the number of logos to your preference

    function createRain() {
      for (let i = 0; i < numberOfLogos; i++) {
        const logo = document.createElement('img')
        logo.src = logoSrc
        logo.classList.add('rain-logo')
        logo.style.left = `${Math.random() * 100}vw`
        logo.style.animationDuration = `${Math.random() * 2 + 9}s` // Random duration between 3s and 5s
        logo.style.animationDelay = `${Math.random() * 5}s` // Random delay up to 5s
        rainContainer.appendChild(logo)
      }
    }

    createRain()
  }, [])

  return (
    <div
      id='rain-container'
      className='z-50'
    ></div>
  )
}

export default Rain
